import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from '~/locales/fr.json';
export const defaultLNG = 'fr';
export const resources = { fr: { translation: fr } };
i18n.use(initReactI18next).init({
    lng: defaultLNG,
    resources,
});
